<template>
  <button class="back-button button" type="button" @click="back">
    <span class="u-screen-reader-only">
      Back
    </span>
    <IconBack />
  </button>
</template>

<script>
import IconBack from 'bootstrap-icons/icons/chevron-left.svg'

export default {
  name: 'BackButton',

  components: {
    IconBack
  },

  methods: {
    back () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss">
.back-button {
  --button-width: 2rem;
  --button-height: 2rem;
}
</style>
